module.exports = __webpack_public_path__ + "static/gm-6-4f69215e9f81dc64f33dc6c23b89a616.jpg";